module Shared.Admin.EnableUser

open Shared
open Illy.SafeStack

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation

    type EnableValidations = 
        | CannotEnableOwnUser
        | AllLicensesAreInUse of totalLicenses: int

    module EnableValidations = 
        let toString = 
            function 
            | CannotEnableOwnUser -> "Cannot enable your own user account."
            | AllLicensesAreInUse x -> sprintf "All %d user licenses are in use." x
    
    let validate (licenses: LicenseCounts) (currentUserId: UserId) (enableUser: UserId) = 
        validate {
            return! !!(error CannotEnableOwnUser)
                >>= conditional pass (fun _ -> enableUser <> currentUserId)
                |> unwrap
            
            return! !!(error (AllLicensesAreInUse licenses.Total))
                >>= conditional pass (fun _ -> licenses.Used + 1 <= licenses.Total)
                |> unwrap
        }

type FailureReason = 
    | NothingToDo
    | FailedValidations of Validation.ValidationResult<Validations.EnableValidations, Validation.NoWarning>
    